export enum EContractEvents {
  DONATION_CREATED = 'donationCreated',
  WITHDRAW_SUCCESS = 'withDrawSuccess',
}
